import React from 'react'
import DeliveryContent from './delivery-content'

const Index = () => {
	return(
		<DeliveryContent/>
	)
}

export default Index